import * as yup from "yup";

import { IAcceptAsPartialPayment } from "../../../../interfaces-and-types";
import { chargeBearer } from "../../../../enums";

export const acceptAsPartialSchema: yup.SchemaOf<IAcceptAsPartialPayment> = yup
  .object({
    transfer_refund_id: yup
      .string()
      .required("Please provide the transfer refund id"),
    transaction_id: yup.string().required("Please provide the transaction id"),
    max_partial_payment_count: yup
      .number()
      .typeError("Permitted partial payment count is required")
      .required("Permitted partial payment count is required")
      .positive(
        "Please set the permitted number of partial payemnts the customer can make to complete payment"
      ),
    bearer: yup
      .mixed<chargeBearer>()
      .oneOf(Object.values(chargeBearer))
      .required("charge bearer is required"),
    description: yup.string().nullable().optional().max(300),
  })
  .required();
